import { EUserLevel } from '../../spa/store/general/types';
import { EContentLibVideoLevel } from '../../spa/store/contentLib/types';

export class LangLevelUtils {

  private static map: Record<EUserLevel, EContentLibVideoLevel[]> = {
    [EUserLevel.UNKNOWN]: [],
    [EUserLevel.BEGINNER]: [EContentLibVideoLevel.A1, EContentLibVideoLevel.A2],
    [EUserLevel.INTERMEDIATE]: [EContentLibVideoLevel.B1, EContentLibVideoLevel.B2],
    [EUserLevel.ADVANCED]: [EContentLibVideoLevel.C1, EContentLibVideoLevel.C2],
  }

  public static getUserLevelByVideoLevel(level: EContentLibVideoLevel): EUserLevel | undefined {
    let entry = Array.from(Object.entries(this.map)).find(([key, value]: any) => value.includes(level));
    return entry ? +entry[0] : undefined;
  }
}
